import {
  SEARCH_INPUT_SOURCING_SUPPLIER_FILTER1,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER2,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER3,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER4,
  SEARCH_OPTION_SOURCING_SUPPLIER_FILTER_EVENT_TYPE,
} from './constants'

const initialStateSearchInput = {
  searchSourcingSupplierInput: '',
  enterSourcingSupplierFilter: null,
}

const initialStateSearchOption2 = {
  searchOptionSourcingSupplierFilter2: 0,
  selectedSourcingSupplierOptions2: null,
}

const initialStateSearchOption3 = {
  searchOptionSourcingSupplierFilter3: 0,
  selectedSourcingSupplierOptions3: null,
}

const initialStateSearchOption4 = {
  searchOptionSourcingSupplierFilter4: 0,
  selectedOptionsSourcingSupplier4: null,
}

const initialStateSearchOptionEventType = {
  searchOptionSourcingSupplierFilterEventType: 0,
  selectedOptionsSourcingSupplierEventType: null,
}

export const searchInputFilterSourcingSupplier = (
  state = initialStateSearchInput,
  action
) => {
  switch (action.type) {
    case SEARCH_INPUT_SOURCING_SUPPLIER_FILTER1:
      return {
        ...state,
        searchSourcingSupplierInput: action.searchValue,
        enterSourcingSupplierFilter: action.enterSearchInputFilter,
      }
    default:
      return state
  }
}
export const searchSelectOptionSourcingSupplier2 = (
  state = initialStateSearchOption2,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_SUPPLIER_FILTER2:
      return {
        ...state,
        searchOptionSourcingSupplierFilter2: action.searchOption2,
        selectedSourcingSupplierOptions2: action.selectedOptions2,
      }
    default:
      return state
  }
}

export const searchSelectOptionSourcingSupplier3 = (
  state = initialStateSearchOption3,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_SUPPLIER_FILTER3:
      return {
        ...state,
        searchOptionSourcingSupplierFilter3: action.searchOption3,
        selectedSourcingSupplierOptions3: action.selectedOptions3,
      }
    default:
      return state
  }
}

export const searchSelectOptionSourcingSupplier4 = (
  state = initialStateSearchOption4,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_SUPPLIER_FILTER4:
      return {
        ...state,
        searchOptionSourcingSupplierFilter4: action.searchOption4,
        selectedOptionsSourcingSupplier4: action.selectedOptions4,
      }
    default:
      return state
  }
}

export const searchSelectOptionSourcingSupplierEventType = (
  state = initialStateSearchOptionEventType,
  action
) => {
  switch (action.type) {
    case SEARCH_OPTION_SOURCING_SUPPLIER_FILTER_EVENT_TYPE:
      return {
        ...state,
        searchOptionSourcingSupplierFilterEventType:
          action.searchOptionEventType,
        selectedOptionsSourcingSupplierEventType:
          action.selectedOptionsEventType,
      }
    default:
      return state
  }
}
